/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any text: a URL, phone number, email, Wi-Fi details, plain message and more. URLs are the most common use.`)
};

const es_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier texto: una URL, un número de teléfono, un correo, datos de Wi-Fi, un mensaje sencillo y más. Las URL son el uso más común.`)
};

const de_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliebigen Text: eine URL, Telefonnummer, E-Mail-Adresse, WLAN-Zugangsdaten, eine einfache Nachricht und mehr. URLs sind die häufigste Anwendung.`)
};

const nl_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke tekst: een URL, telefoonnummer, e-mailadres, wifi-gegevens, een gewoon bericht en meer. URL's zijn het meest gebruikelijk.`)
};

const fr_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N'importe quel texte : une URL, un numéro de téléphone, un e-mail, des détails Wi-Fi, un simple message et plus encore. Les URL sont l'usage le plus courant.`)
};

const it_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualsiasi testo: un URL, un numero di telefono, un'email, dati Wi-Fi, un messaggio semplice e altro. Gli URL sono l'uso più comune.`)
};

const pt_br2_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer texto: uma URL, número de telefone, e-mail, dados de Wi-Fi, mensagem simples e muito mais. URLs são o uso mais comum.`)
};

const pt_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer texto: um URL, número de telefone, e-mail, dados de Wi-Fi, mensagem simples e muito mais. Os URLs são o uso mais comum.`)
};

const ja_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL、電話番号、メール、Wi-Fi情報、通常のメッセージなど、任意のテキストを入れられます。URLが最も一般的な用途です。`)
};

const zh_qr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何文本：网址、电话号码、邮箱、Wi-Fi 信息、普通消息等等。网址是最常见的用途。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_a1", locale)
	if (locale === "en") return en_qr_faq_a1(inputs)
	if (locale === "es") return es_qr_faq_a1(inputs)
	if (locale === "de") return de_qr_faq_a1(inputs)
	if (locale === "nl") return nl_qr_faq_a1(inputs)
	if (locale === "fr") return fr_qr_faq_a1(inputs)
	if (locale === "it") return it_qr_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_a1(inputs)
	if (locale === "pt") return pt_qr_faq_a1(inputs)
	if (locale === "ja") return ja_qr_faq_a1(inputs)
	return zh_qr_faq_a1(inputs)
};